import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
export function Proof() {
  return <section className="py-24 bg-cream" data-id="element-156">
      <div className="max-w-4xl mx-auto px-6 text-center" data-id="element-157">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8
      }} className="bg-white p-10 md:p-16 rounded-3xl shadow-sm border border-navy/5" data-id="element-158">
          <div className="flex justify-center space-x-2 mb-8" data-id="element-159">
            {[1, 2, 3, 4, 5].map(star => <Star key={star} className="w-6 h-6 text-amber fill-amber" data-id="element-160" />)}
          </div>

          <h2 className="text-3xl md:text-4xl font-serif text-navy mb-8" data-id="element-161">
            Lo que cambia en 7 días
          </h2>

          <p className="text-xl md:text-2xl text-navy/80 leading-relaxed font-light italic" data-id="element-162">
            "No prometemos que tu bebé sea un robot, pero prometemos que en una
            semana pasarás de despertarte 6 veces por noche a tener despertares
            predecibles, cortos y, en muchos casos, noches completas de 6 a 8
            horas de paz."
          </p>
        </motion.div>
      </div>
    </section>;
}